var map = {
	"./icon_ranking_1.png": "OmW1",
	"./icon_ranking_2.png": "ndJp",
	"./icon_ranking_3.png": "4ISD",
	"./icon_ranking_other.png": "ZhWQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gwwJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/icon_ranking_.*\.png$
// module id = gwwJ
// module chunks = 96